// extracted by mini-css-extract-plugin
export default {"root":"Loading_root__gDqE0"};